import React from 'react';
import { I18n } from '@aws-amplify/core';

import { getColor } from '../../utils';
import { Title } from '@/components/Typography';
import { RiskSegmentPropsDTO } from '../../types';
import * as S from './styles';

export function RiskSegment({ segments }: Readonly<RiskSegmentPropsDTO>): JSX.Element {
	return (
		<S.StyledRiskDiv>
			<Title level={4}>Risk by segment and exposure time</Title>
			{segments?.map((segment: any) => (
				<S.StyledDivRiskSegment key={segment?.id}>
					<Title level={4}>{segment?.description}</Title>
					<div>
						{segment?.values?.map((value: any) => (
							<S.StyledRowRiskType>
								<S.StyledColRiskTypeName>
									<h3>{I18n.get(value?.description)}</h3>
								</S.StyledColRiskTypeName>
								<S.StyledColRiskTypePercentage>
									<S.RiskSquare
										className={value?.percentage === 0 ? 'border-gray' : ''}
										color={getColor(value?.score, value?.percentage)}
									>
										<span className={value?.percentage === 0 ? 'color-1' : 'color-2'}>
											{Math.floor(value?.percentage)}%
										</span>
									</S.RiskSquare>
								</S.StyledColRiskTypePercentage>
							</S.StyledRowRiskType>
						))}
					</div>
				</S.StyledDivRiskSegment>
			))}
		</S.StyledRiskDiv>
	);
}
